import axios from "axios";
import { message, Modal } from "ant-design-vue";
import store from "@/store";
import router from "@/router";
const baseURL = process.env.VUE_APP_REQUEST_BASE_URL;
const request = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});
//  请求前
request.interceptors.request.use(
  (config) => {
    store.commit("setLoadingState", true);
    config.headers["client-type"] = "web";
    //  token
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);
request.interceptors.response.use(
  (res) => {
    setTimeout(() => {
      store.commit("setLoadingState", false);
    }, 300);
    if (![200, 201].includes(res.status)) {
      Modal.error({
        title: "操作错误",
        content: res.response.data.message,
      });
      return Promise.reject(res);
    }
    return res.data;
  },
  (err) => {
    //  如果是 403 401 跳转登录
    store.commit("setLoadingState", false);

    if ([403, 401].includes(err.response.status)) {
      message.error("请先登录");
      router.push("/user/login");
      return Promise.reject(err);
    }
    Modal.error({
      title: "操作错误",
      content: "服务器错误 ~ " + err.response.data.message,
    });
    return Promise.reject(err);
  },
);

export default request;
